import { ref } from "@vue/composition-api";

export const keepAliveInclude = ref([]);

export function addKeepAliveInclude(to, from, next) {
  if (to.meta && to.meta.componentName) {
    if (
      !keepAliveInclude.value.some(
        (route) => route.meta.componentName === to.meta.componentName,
      )
    ) {
      keepAliveInclude.value.push(to);
    }
  }
  next();
}



// WEBPACK FOOTER //
// ./src/util/keepAlive.js